module.exports = __webpack_public_path__ + "img/buzzsprout.68228ff8.svg";